import momentTz from 'moment-timezone';
import moment from 'moment';
import i18n from '@/i18n';
import DEFINES from '@/defines';
import Vue from 'vue';
import {getAuthHash} from '@/api/_manager';

const getRemainingTime = subscription => {
  var today = moment ();
  var trial_end = moment.unix (subscription.trial_end);
  if (subscription.trial_end && trial_end > today) {
    return getTimeDifference (trial_end);
  }
  if (subscription.cancel_at_period_end) {
    var period_end = moment.unix (subscription.current_period_end);
    return getTimeDifference (period_end);
  }
};

const getTimeDifference = end_date => {
  return moment.utc (end_date).local ().fromNow ();
};

const getZoomUrl = (screener_id, meetingNo, meetingPassword) => {
  return (
    process.env.VUE_APP_SERVER_URL +
    'screener/' +
    screener_id +
    '/' +
    meetingNo +
    '/' +
    meetingPassword
  );
};

const getFacebookLiveEmbedUrl = videoId => {
  return process.env.VUE_APP_SERVER_URL + 'screener/facebook/' + videoId;
};

const getVimeoEmbedUrl = vimeo_live_id => {
  return 'https://vimeo.com/event/' + vimeo_live_id + '/embed';
};

const getVimeoChatEmbedUrl = vimeo_live_id => {
  return 'https://vimeo.com/event/' + vimeo_live_id + '/chat/';
};

const getYoutubeLiveEmbedUrl = videoId => {
  return 'https://www.youtube.com/embed/'+videoId
};

const getJitsiLiveEmbedUrl = () => {
  let uuid = Math.random().toString(36).substring(7); ;
  return 'https://meet.jit.si/'+ uuid;
};

const getFormattedTimeString = (milliseconds, dateTimeFormat) => {
  return moment.unix (milliseconds).format (dateTimeFormat);
};

const getFormattedPlanDescription = tiers => {
  let currency = i18n.t ('subscription.currency.usd');
  let per_gb = i18n.t ('subscription.per_gb');
  let month = i18n.t ('subscription.month');
  return `${currency}${tiers[0].flat_amount / 100} / ${month} + ${currency}${tiers[1].unit_amount_decimal / 100} ${per_gb} / ${month}`;
};

const isCompanyOwnerOrAdmin = role => {
  return DEFINES.ROLE_ADMIN == role || DEFINES.ROLE_OWNER == role;
};

const setAccessTokenCookie = () => {
  Vue.cookie.set (DEFINES.SK_MEDIA_TOKEN, JSON.stringify(getAuthHash()), 1);
};

const unsetAccessTokenCookie = () => {
  Vue.cookie.delete (DEFINES.SK_MEDIA_TOKEN);
};

const convertLocalTimeToUtc = localTime => {
  return moment (localTime).utc ().format ('YYYY-MM-DD HH:mm:ss');
};

const convertUtcTimeToLocal = utcTime => {
  return moment.utc (utcTime).local ().format ('YYYY-MM-DD HH:mm:ss');
};

const tzToUtc = (input, timezone, fmt = 'YYYY-MM-DD HH:mm:ss') => {
  if(!input){
    return null;
  }
  return momentTz
    .tz (input, 'YYYY-MM-DD HH:mm:ss', timezone)
    .utc ()
    .format (fmt);
};

const utcToTz = (input, timezone, fmt = 'YYYY-MM-DD HH:mm:ss') => {
  return momentTz.utc (input, 'YYYY-MM-DD HH:mm:ss').tz (timezone).format (fmt);
};

const calDateToMin = (input1, input2, fmt = 'YYYY-MM-DD HH:mm:ss') => {
  var start = moment (input1);
  var end = moment (input2);
  var duration = moment.duration (end.diff (start));
  return duration.asMinutes (); // return minutes
};

const calMinToDate = (date, minutes, fmt = 'YYYY-MM-DD HH:mm:ss') => {
  return moment (date).add (minutes, 'minutes').format (fmt);
};

const getCurrencySymbol = currency => {
  if (!currency) return;
  return DEFINES.MONETIZATION.CURRENCIES.find (
    currencyObj => currency.toLowerCase () == currencyObj.value.toLowerCase ()
  ).symbol;
};

const isDateFuture = (f_date, t_date = moment ()) => {
  let today_date = t_date;
  let future_date = moment.utc (f_date).local ();
  /* future - today > 0  || today - future < 0 */
  return future_date.diff (today_date) > 0;
};

const timezonesByCountry = ()=>{
  var SUPPORTED_COUNTRIES = ["AT", "AU", "BE", "BG", "BR", "BY", "CA", "CH", "CO", "CZ", "DE", "DK", "FI", "FR", "HK", "HU", "IE", "IL", "IN", "JP", "KR", "LI", "LU", "MC", "MD", "MX", "NL", "NO", "NZ", "PE", "PH", "PL", "RO", "RU", "SE", "SG", "SK", "UA", "US", "ZA"];
  var timezones = [];
  SUPPORTED_COUNTRIES.map(function(countryCode){
    timezones = timezones.concat(moment.tz.zonesForCountry(countryCode));
  });
  timezones = timezones.filter(function(timezone){
    var z = momentTz.tz(timezone).format("z");
    return isNaN(z);
  })
  return timezones.sort();
};

export {
  convertUtcTimeToLocal,
  convertLocalTimeToUtc,
  tzToUtc,
  utcToTz,
  getRemainingTime,
  getTimeDifference,
  getFormattedTimeString,
  getFormattedPlanDescription,
  isCompanyOwnerOrAdmin,
  setAccessTokenCookie,
  unsetAccessTokenCookie,
  calDateToMin,
  calMinToDate,
  getZoomUrl,
  getVimeoEmbedUrl,
  getVimeoChatEmbedUrl,
  getCurrencySymbol,
  getFacebookLiveEmbedUrl,
  isDateFuture,
  getYoutubeLiveEmbedUrl,
  getJitsiLiveEmbedUrl,
  timezonesByCountry,
};
